export default {
    title: "",
    unavailable: "Ce produit n'est plus disponible."
}